import type { Ref } from 'vue';
import {
  ref,
  watch,
} from 'vue';

import type { AppBreakpoints } from '@modules/core/composables/breakpoints/types';
import { useAppBreakpoints } from '@modules/core/composables/breakpoints';

export interface DeviceComposable {
  breakpoints: AppBreakpoints;
  isDesktop: Ref<boolean>;
  isMobile: Ref<boolean>;
}

export default function useDevice(): DeviceComposable {
  const breakpoints = useAppBreakpoints();

  const isDesktop = ref(false);
  const isMobile = ref(false);

  watch(
    breakpoints.lg,
    () => {
      isDesktop.value = breakpoints.isGreater('lg');
      isMobile.value = breakpoints.isSmallerOrEqual('lg');
    },
    { immediate: true },
  );

  return { breakpoints, isDesktop, isMobile };
}
